<template>
  <div class="page-detail">
    <div class="g-wrap">
      <el-breadcrumb class="g-breadcrumb" separator="/">
        <el-breadcrumb-item :to="`${$subsitePrefix}/ss`"
          >社会服务</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="breadcrumbPath">{{
          this.breadcrumb
        }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ model.HeadLine }}</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="g-content">
        <div class="head">
          <el-button class="link" type="primary" @click="share" round>
            分享<i class="el-icon-share"></i>
          </el-button>
          <h3 class="title">{{ model.HeadLine }}</h3>
          <div class="attrs">
            <!-- <p>展示时间：{{ formartDate(model.PublishTime,"day") }}</p> -->
            <!-- <p>活动地点：{{ model.addr }}</p> -->
          </div>
        </div>
        <!-- <el-button type="primary" plain class="share" @click="share" size="mini" icon="el-icon-share" circle></el-button> -->
        <column-header2 :data="{ name: '摘要' }"></column-header2>
        <div v-html="model.Summary"></div>
        <column-header2 :data="{ name: '内容' }"></column-header2>
        <div v-html="model.Content"></div>
        <!-- <div class="head">
          <el-button class="link" type="primary" round>马上报名</el-button>
          <h3 class="title">{{ model.title }}</h3>
          <div class="attrs">
            <p>活动时间：{{ model.time }}</p>
            <p>活动地点：{{ model.addr }}</p>
          </div>
        </div>
        <column-header2 :data="{name:'活动详情'}"></column-header2>
        <div class="content" v-html="model.content"></div>
        <div class="relative">
          <div class="prev">
            上一篇：
            <router-link v-if="model.prev" :to="`${$subsitePrefix}/ah/column/detail/` + model.prev.id">{{ model.prev.title }}</router-link>
            <span v-else>没有了</span>
          </div>
          <div class="next">
            下一篇：
            <router-link v-if="model.next" :to="`${$subsitePrefix}/ah/column/detail/` + model.next.id">{{ model.next.title }}</router-link>
            <span v-else>没有了</span>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import tools from "@/mixins/content-tools";
import { getDetail } from "api/app";
import ColumnHeader from "_c/ColumnHeader2";
export default {
  mixins: [tools],
  data() {
    const $subsitePrefix = this.$subsitePrefix;
    return {
      model: {
        title: "",
        time: "",
        source: "",
        content: "",
        id: "1",
        prev: null,
        next: null
      },
      id: null,
      name: null,
      breadcrumbPath: "",
      cateList: [
        {
          id: 1,
          name: "咨询服务",
          link: `${$subsitePrefix}/ss/society/consult/list/1`,
          value: "ConsultingService"
        },
        {
          id: 2,
          name: "公益活动",
          link: `${$subsitePrefix}/ss/society/consult/list/2`,
          value: "PublicService"
        },
        {
          id: 3,
          name: "新技术应用",
          link: `${$subsitePrefix}/ss/society/consult/list/3`,
          value: "GuidingActivity"
        },
        {
          id: 4,
          name: "成果分享",
          link: `${$subsitePrefix}/ss/society/consult/list/4`,
          value: "TeachingResource"
        },
        {
          id: 5,
          name: "社会服务",
          link: `${$subsitePrefix}/ss/society/consult/list/5`,
          value: "SocialServiceShow"
        }
      ]
    };
  },
  components: {
    [ColumnHeader.name]: ColumnHeader
  },
  computed: {
    breadcrumb() {
      var text = "";
      this.cateList.forEach(item => {
        if (this.$route.params.id == item.value) {
          text = item.name;
          this.breadcrumbPath = item.link;
        }
      });
      return text;
    }
  },
  created() {
    this.init();
  },
  watch: {
    $route() {
      this.init();
    }
  },
  methods: {
    loadData() {
      getDetail({ name: this.name, id: this.id }).then(res => {
        this.model = res || {};
      });
    },
    init() {
      this.name = this.$route.params.id;
      this.id = this.$route.query.id;
      this.loadData();
    },
    share() {
      window.localStorage.setItem("shareUrl", window.location.href);
      this.$router.push(this.$subsitePrefix + "/share-page");
    }
  }
};
</script>

<style lang="scss" scoped>
.page-detail {
  background: #f6f6f9;
  padding-bottom: 40px;
  .g-content {
    position: relative;
  }
  .share {
    position: absolute;
    top: 24px;
    right: 24px;
  }
  .title {
    font-size: 32px;
    color: #333333;
    font-weight: 500;
    padding: 8px 0 15px 0;
    line-height: 1.4em;
  }
  .head {
    margin: 0 -72px 0 -72px;
    border-bottom: 1px solid #eee;
    padding: 0 72px;
    overflow: hidden;
    .link {
      float: right;
      margin-top: 40px;
    }
  }
  .attrs {
    font-size: 16px;
    color: #999999;
    line-height: 28px;
    padding-bottom: 24px;
  }
  .content {
    font-size: 18px;
    color: rgba(51, 51, 51, 1);
    line-height: 1.8em;
    ::v-deep p {
      text-indent: 2em;
      padding-bottom: 1em;
    }
  }
  .relative {
    display: flex;
    justify-content: space-between;
    padding: 16px 0;
    border-top: 1px solid #eee;
    margin-top: 40px;
    font-size: 16px;
    .prev {
    }
    .next {
    }
  }
  .g-content {
    padding: 24px 72px 40px 72px;
  }
}
</style>
